import styled from 'styled-components';

const SectionTitleWrapper = styled.div`
    padding-top: 6.5rem;
    padding-bottom: 3.2rem;

    @media only screen and (max-width: ${({ theme }) => theme.mediaQueries.s}) {
        padding-top: 4rem;
    }
`;

export default SectionTitleWrapper;
